module.exports = __webpack_public_path__ + "static/media/logoTracker.e4697eb9.png";